import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./datastrategydecaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const DataStrategyDecAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=&eventid=2866285&sessionid=1&key=652A5EFEDED8CEEFF08BAC7E729F71E9&regTag=&sourcepage=register" target="_blank" className="pinkify">Watch the On-Demand session</a> from SNG Live: Data Strategy. We had an important session that gathered CDOs from across government to discuss the progress they’re making around data challenges and the role data is playing in the fight against the pandemic.<br /><br />

In our first panel Kirsten Dalboe, Chief Data Officer of the Federal Energy Regulatory Commission and Henry Sowell, CIO & Technical Director of Cloudera Government Solutions Inc. discussed maturing data processes. <br /><br />

Our second panel— on making data standards— featured Dr. Kathleen Kaplan, Chief Data Officer of FEMA and Ray Holder, Executive Strategist, U.S. Federal for AWS. <br /><br />
 
To close out the session, Chris Haffer, Chief Data Officer of the U.S. Equal Employment Opportunity Commission, Anne Levine, Deputy Chief Data Officer of the FCC’s Office of Economics & Analytics and Steven Septoff, Vice President, U.S. Federal for Dell Technologies discussed how federal agencies can set data expectations for 2021.  <br /><br />

                    </p>
                        
                        <p>
                        <a className="regmobwatch" href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=&eventid=2866285&sessionid=1&key=652A5EFEDED8CEEFF08BAC7E729F71E9&regTag=&sourcepage=register" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=&eventid=2866285&sessionid=1&key=652A5EFEDED8CEEFF08BAC7E729F71E9&regTag=&sourcepage=register" target="_blank">WATCH NOW »</a>
                        
                
                    </div>
                    
                    
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "dec")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                       
                    </div>
                </div>
                <div className="grid gridContain2">
                <div className="grid1">
                    {/*<h3 className="wrapsub">Thought Leadership Resources</h3>
                    <p className="underabout">
                        
                         
                         Take a look at the <a href="https://cdn.fedscoop.com/Zscaler-SASE-Based-TIC-3.0.pdf" target="_blank" className="pinkify">Modernizing Cloud and Internet Access with SASE-Based TIC 3.0 Solutions Brief</a> by Zscaler

                        </p>*/}
                </div>
                </div>
            </div>
            
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "dec")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default DataStrategyDecAboutWrap